<template>
  <div>
    <!-- {{this.viewwork.response}} -->
    <!-- Created -->
    <div
      v-if="
        this.viewwork.response == 'Created' 
        
      "
      class="stepper-wrapper"
      style="padding: 30px 0; font-size: 10px"
    >
      <div class="stepper-item active">
        <div class="step-counter" style="color: #ffffff">1</div>
        <div class="step-name" style="color: #32c040">Created</div>

        <div>{{ this.resCreated[0].username }}</div>
        <div>
          {{ $moment(this.resCreated[0].timestamp).format("YYYY-MM-DD HH:mm:ss") }}
        </div>
      </div>
      <div class="stepper-item inative">
        <div class="step-counter">2</div>
        <div class="step-name">Acknowledged</div>
      </div>
      <div class="stepper-item inative">
        <div class="step-counter">3</div>
        <div class="step-name">Submitted</div>
      </div>
      <div class="stepper-item inative">
        <div class="step-counter">4</div>
        <div class="step-name">Completed</div>
      </div>
    </div>
    <!-- Acknowledged -->
    <div
      v-if="this.viewwork.response == 'Acknowledged'"
      class="stepper-wrapper"
      style="padding: 30px 0; font-size: 10px"
    >
      <div class="stepper-item completed">
        <div class="step-counter" style="color: #32c040">1</div>
        <div class="step-name">Created</div>
        <div>{{ this.resCreated[0].username }}</div>
        <div>
          <a style="font-size: 6px"
            >{{ $moment(this.resCreated[0].timestamp).format("YYYY-MM-DD HH:mm:ss") }}
          </a>
        </div>
      </div>
      <div class="stepper-item active">
        <div class="step-counter" style="color: #ffffff">2</div>
        <div class="step-name" style="color: #32c040">Acknowledged</div>
        <div>{{ this.resAcknowledged[0].username }}</div>
        <div>
          <a style="font-size: 6px"
            >{{ $moment(this.resAcknowledged[0].timestamp).format("YYYY-MM-DD HH:mm:ss") }}
          </a>
        </div>
      </div>
      <div class="stepper-item inative">
        <div class="step-counter">3</div>
        <div class="step-name">Submitted</div>
      </div>
      <div class="stepper-item inative">
        <div class="step-counter">4</div>
        <div class="step-name">Completed</div>
      </div>
    </div>

    <div
      v-if="this.viewwork.response == 'Submitted'"
      class="stepper-wrapper"
      style="padding: 30px 0; font-size: 10px"
    >
      <div class="stepper-item completed">
        <div class="step-counter" style="color: #32c040">1</div>
        <div class="step-name">Created</div>
        <div>{{ this.resCreated[0].username }}</div>
        <div>
          <a style="font-size: 6px"
            >{{ $moment(this.resCreated[0].timestamp).format("YYYY-MM-DD HH:mm:ss") }}
          </a>
        </div>
      </div>
      <div class="stepper-item completed">
        <div class="step-counter" style="color: #32c040">2</div>
        <div class="step-name">Acknowledged</div>
        <div>{{ this.resAcknowledged[0].username }}</div>
        <div>
          {{ $moment(this.resAcknowledged[0].timestamp).format("YYYY-MM-DD HH:mm:ss") }}
        </div>
      </div>
      <div class="stepper-item active">
        <div class="step-counter" style="color: #ffffff">3</div>
        <div class="step-name" style="color: #32c040">Submitted</div>
        <div>{{ this.resSubmitted[0].username }}</div>
        <div>
          <a style="font-size: 6px"
            >{{ $moment(this.resSubmitted[0].timestamp).format("YYYY-MM-DD HH:mm:ss") }}
          </a>
        </div>
      </div>
      <div class="stepper-item inative">
        <div class="step-counter">4</div>
        <div class="step-name">Completed</div>
        <!-- <div>{{ viewwork.username }}</div>
          <div>
            {{ $moment(viewwork.timestamp).format("YYYY-MM-DD HH:mm:ss") }}
          </div> -->
      </div>
    </div>
    <div
      v-if="this.viewwork.response == 'Approved'"
      class="stepper-wrapper"
      style="padding: 30px 0; font-size: 10px"
    >
      <div class="stepper-item completed">
        <div class="step-counter" style="color: #32c040">1</div>
        <div class="step-name">Created</div>
        <div>{{ this.resCreated[0].username }}</div>
        <div>
          <a style="font-size: 6px"
            >{{ $moment(this.resCreated[0].timestamp).format("YYYY-MM-DD HH:mm:ss") }}
          </a>
        </div>
      </div>
      <div class="stepper-item completed">
        <div class="step-counter" style="color: #32c040">2</div>
        <div class="step-name">Acknowledged</div>
        <div>{{ this.resAcknowledged[0].username }}</div>
        <div>
          {{ $moment(this.resAcknowledged[0].timestamp).format("YYYY-MM-DD HH:mm:ss") }}
        </div>
      </div>
      <div class="stepper-item completed">
        <div class="step-counter" style="color: #32c040">3</div>
        <div class="step-name">Submitted</div>
        <div>{{ this.resSubmitted[0].username }}</div>
        <div>
          <a style="font-size: 6px"
            >{{ $moment(this.resSubmitted[0].timestamp).format("YYYY-MM-DD HH:mm:ss") }}
          </a>
        </div>
      </div>
      <div class="stepper-item active">
        <div class="step-counter" style="color: #ffffff">4</div>
        <div class="step-name" style="color: #32c040">Completed </div>
        <div>{{ this.resApproved[0].username }}</div>
        <div>
          <a style="font-size: 6px"
            >{{ $moment(this.resApproved[0].timestamp).format("YYYY-MM-DD HH:mm:ss") }}
          </a>
        </div>
      </div>
    </div>

    <!-- Declined -->
    <div
      v-if="this.viewwork.response == 'Declined'"
      class="stepper-wrapper"
      style="padding: 30px 0; font-size: 10px"
    >
      <div class="stepper-item rejected">
        <div class="step-counter textWarning">1</div>
        <div class="step-name">Created</div>
        <div>{{ this.resCreated[0].username }}</div>
        <div>
          <a style="font-size: 6px"
            >{{ $moment(this.resCreated[0].timestamp).format("YYYY-MM-DD HH:mm:ss") }}
          </a>
        </div>
      </div>
      <div class="stepper-item rejectedFocus active">
        <div class="step-counter" style="color: #ffffff">2</div>
        <div class="step-name textWarning">Declined</div>
        <div>{{ this.resDeclined[0].username }}</div>
        <div>
          <a style="font-size: 6px"
            >{{ $moment(this.resDeclined[0].timestamp).format("YYYY-MM-DD HH:mm:ss") }}
          </a>
        </div>
      </div>
      <div class="stepper-item inative">
        <div class="step-counter">3</div>
        <div class="step-name">Submitted</div>
      </div>
      <div class="stepper-item inative">
        <div class="step-counter">4</div>
        <div class="step-name">Completed</div>
      </div>
    </div>

    <div
      v-if="this.viewwork.response == 'Rejected'"
      class="stepper-wrapper"
      style="padding: 30px 0; font-size: 10px"
    >
      <div class="stepper-item rejected">
        <div class="step-counter textWarning">1</div>
        <div class="step-name">Created</div>
        <div>{{ this.resCreated[0].username }}</div>
        <div>
          <a style="font-size: 6px"
            >{{ $moment(this.resCreated[0].timestamp).format("YYYY-MM-DD HH:mm:ss") }}
          </a>
        </div>
      </div>
      <div class="stepper-item rejected">
        <div class="step-counter textWarning">2</div>
        <div class="step-name">Acknowledged</div>
        <div>{{ this.resAcknowledged[0].username }}</div>
        <div>
          {{ $moment(this.resAcknowledged[0].timestamp).format("YYYY-MM-DD HH:mm:ss") }}
        </div>
      </div>
      <div class="stepper-item rejected">
        <div class="step-counter textWarning">3</div>
        <div class="step-name">Submitted</div>
        <div>{{ this.resSubmitted[0].username }}</div>
        <div>
          <a style="font-size: 6px"
            >{{ $moment(this.resSubmitted[0].timestamp).format("YYYY-MM-DD HH:mm:ss") }}
          </a>
        </div>
      </div>
      <div class="stepper-item rejectedFocus active">
        <div class="step-counter" style="color: #ffffff">4</div>
        <div class="step-name textWarning">Rejected</div>
        <div>{{this.resRejected[0].username }}</div>
        <div>
          <a style="font-size: 6px"
            >{{ $moment(this.resRejected[0].timestamp).format("YYYY-MM-DD HH:mm:ss") }}
          </a>
        </div>
      </div>
    </div>

    <div
      v-if="this.viewwork.response == 'Cancelled'"
      class="stepper-wrapper"
      style="padding: 30px 0; font-size: 10px"
    >
      <div class="stepper-item rejected">
        <div class="step-counter textWarning">1</div>
        <div class="step-name">Created</div>
        <div>{{ this.resCreated[0].username }}</div>
        <div>
          <a style="font-size: 6px"
            >{{ $moment(this.resCreated[0].timestamp).format("YYYY-MM-DD HH:mm:ss") }}
          </a>
        </div>
      </div>
      <div class="stepper-item rejected">
        <div class="step-counter textWarning">2</div>
        <div class="step-name">Declined</div>
        <div>{{this.resDeclined[0].username }}</div>
        <div>
          {{ $moment(this.resDeclined[0].timestamp).format("YYYY-MM-DD HH:mm:ss") }}
        </div>
      </div>
      <div class="stepper-item rejected">
        <div class="step-counter textWarning">3</div>
        <div class="step-name">Submitted</div>
        <!-- <div>{{ this.resSubmitted[0].username }}</div>
        <div>
          <a style="font-size: 6px"
            >{{ $moment(this.resSubmitted[0].timestamp).format("YYYY-MM-DD HH:mm:ss") }}
          </a>
        </div> -->
      </div>
      <div class="stepper-item rejectedFocus active">
        <div class="step-counter" style="color: #ffffff">4</div>
        <div class="step-name textWarning">Cancelled</div>
        <div>{{this.resCancelled[0].username }}</div>
        <div>
          <a style="font-size: 6px"
            >{{ $moment(this.resCancelled[0].timestamp).format("YYYY-MM-DD HH:mm:ss") }}
          </a>
        </div>
      </div>
    </div>
    <!-- <pre>{{ this.actionResponse }}</pre>
    <pre>{{this.resDeclined[0].timestamp}}</pre> -->
  </div>
</template>

<script>
export default {
  props: { viewwork: Array },
  data: () => ({
    actionResponse: [],
    resCreated: [],
    resAcknowledged: [],
    resSubmitted: [],
    resRejected: [],
    resDeclined: [],
    resApproved: [],
    resCancelled: [],
  }),
  mounted() {
    console.log(this.viewwork.id);
    this.$API.get(`work/${this.viewwork.id}/response`).then((result) => {
      this.actionResponse = result.data;
      result.data.forEach((element) => {
        console.log(element.response);
        switch (element.response) {
          case "created":
            this.resCreated.push(element);
            break;
            case "Created":
            this.resCreated.push(element);
            break;
          case "Acknowledged":
            this.resAcknowledged.push(element);
            break;
          case "Submitted":
            this.resSubmitted.push(element);
            break;
          case "Approved":
            this.resApproved.push(element);
            break;
          case "Rejected":
            this.resRejected.push(element);
            break;
          case "Declined":
            this.resDeclined.push(element);
            break;
            case "Cancelled":
            this.resCancelled.push(element);
            break;
          default:
            console.log("Try looking up for a hint.");
        }
      });
    });
  },
};
</script>

<style>
</style>